'use strict';

var objectWithoutProperties = require('../../../../@babel/runtime/helpers/esm/objectWithoutProperties.js');
var defineProperty = require('../../../../@babel/runtime/helpers/esm/defineProperty.js');
var React = require('react');
var PropTypes = require('prop-types');
var capitalize = require('../utils/capitalize.js');
var withStyles = require('../styles/withStyles.js');
var useTheme = require('../styles/useTheme.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return n;
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var styles = function styles(theme) {
  var hidden = {
    display: 'none'
  };
  return theme.breakpoints.keys.reduce(function (acc, key) {
    acc["only".concat(capitalize(key))] = defineProperty({}, theme.breakpoints.only(key), hidden);
    acc["".concat(key, "Up")] = defineProperty({}, theme.breakpoints.up(key), hidden);
    acc["".concat(key, "Down")] = defineProperty({}, theme.breakpoints.down(key), hidden);
    return acc;
  }, {});
};
/**
 * @ignore - internal component.
 */


function HiddenCss(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      only = props.only,
      other = objectWithoutProperties(props, ["children", "classes", "className", "only"]);

  var theme = useTheme();

  if (process.env.NODE_ENV !== 'production') {
    var unknownProps = Object.keys(other).filter(function (propName) {
      var isUndeclaredBreakpoint = !theme.breakpoints.keys.some(function (breakpoint) {
        return "".concat(breakpoint, "Up") === propName || "".concat(breakpoint, "Down") === propName;
      });
      return isUndeclaredBreakpoint;
    });

    if (unknownProps.length > 0) {
      console.error("Material-UI: Unsupported props received by `<Hidden implementation=\"css\" />`: ".concat(unknownProps.join(', '), ". Did you forget to wrap this component in a ThemeProvider declaring these breakpoints?"));
    }
  }

  var clsx = [];

  if (className) {
    clsx.push(className);
  }

  for (var i = 0; i < theme.breakpoints.keys.length; i += 1) {
    var breakpoint = theme.breakpoints.keys[i];
    var breakpointUp = props["".concat(breakpoint, "Up")];
    var breakpointDown = props["".concat(breakpoint, "Down")];

    if (breakpointUp) {
      clsx.push(classes["".concat(breakpoint, "Up")]);
    }

    if (breakpointDown) {
      clsx.push(classes["".concat(breakpoint, "Down")]);
    }
  }

  if (only) {
    var onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(function (breakpoint) {
      clsx.push(classes["only".concat(capitalize(breakpoint))]);
    });
  }

  return /*#__PURE__*/React__namespace.createElement("div", {
    className: clsx.join(' ')
  }, children);
}

process.env.NODE_ENV !== "production" ? HiddenCss.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes__default["default"].node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes__default["default"].object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes__default["default"].string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: PropTypes__default["default"].oneOf(['js', 'css']),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  lgDown: PropTypes__default["default"].bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  lgUp: PropTypes__default["default"].bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  mdDown: PropTypes__default["default"].bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  mdUp: PropTypes__default["default"].bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: PropTypes__default["default"].oneOfType([PropTypes__default["default"].oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes__default["default"].arrayOf(PropTypes__default["default"].oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  smDown: PropTypes__default["default"].bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  smUp: PropTypes__default["default"].bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xlDown: PropTypes__default["default"].bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xlUp: PropTypes__default["default"].bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xsDown: PropTypes__default["default"].bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xsUp: PropTypes__default["default"].bool
} : void 0;
var HiddenCss$1 = withStyles(styles, {
  name: 'PrivateHiddenCss'
})(HiddenCss);

module.exports = HiddenCss$1;
